/* Elevia cart helpers: upsell "Add" buttons + initials engraving on cart lines.
   Loaded globally (layout/theme.liquid) so it works even when the page was opened with an empty cart. */
(function () {
  if (window.__eleviaCart) return;
  window.__eleviaCart = true;

  var addBusy = false;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (c) {
      if (c.dataset.sectionId && ids.indexOf(c.dataset.sectionId) === -1) ids.push(c.dataset.sectionId);
    });
    return ids.join(',');
  }

  async function upsellAdd(btn) {
    if (addBusy || btn.disabled) return;
    addBusy = true;
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '...';
    try {
      var body = new FormData();
      body.append('id', btn.dataset.upsellAdd);
      body.append('quantity', '1');
      body.append('sections', sectionIds());
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        body: body,
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      var json = await res.json();
      if (json.status) throw new Error(json.description || json.message);
      var cart = await (await fetch('/cart.js')).json();
      var ev = await import('@theme/events');
      document.dispatchEvent(
        new ev.CartAddEvent(cart, btn.dataset.upsellAdd, { source: 'cart-upsell', itemCount: 1, sections: json.sections })
      );
    } catch (err) {
      console.error(err);
    } finally {
      addBusy = false;
      if (btn.isConnected) {
        btn.textContent = label;
        btn.disabled = false;
      }
    }
  }

  function cleanInitials(v) {
    return String(v || '').toUpperCase().replace(/[^\p{L}]/gu, '').slice(0, 2);
  }

  function showForm(wrap, open) {
    var form = wrap.querySelector('[data-engrave-form]');
    var link = wrap.querySelector('[data-engrave-open]');
    form.hidden = !open;
    link.hidden = open;
    var err = wrap.querySelector('[data-engrave-error]');
    if (err) err.hidden = true;
    if (open) {
      var input = form.querySelector('input');
      input.value = cleanInitials(wrap.dataset.engraveValue);
      input.focus();
    }
  }

  async function engraveSave(wrap) {
    var input = wrap.querySelector('[data-engrave-form] input');
    var saveBtn = wrap.querySelector('[data-engrave-save]');
    var err = wrap.querySelector('[data-engrave-error]');
    var value = cleanInitials(input.value);
    input.value = value;
    if (saveBtn.disabled) return;
    saveBtn.disabled = true;
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: wrap.dataset.key,
          quantity: Number(wrap.dataset.qty),
          properties: { Engraving: value },
          sections: sectionIds(),
          sections_url: window.location.pathname,
        }),
      });
      var json = await res.json();
      if (json.status || json.errors || !json.sections) throw new Error(json.description || json.message || 'error');
      var ev = await import('@theme/events');
      document.dispatchEvent(
        new ev.CartUpdateEvent(json, 'elevia-engrave', {
          source: 'elevia-engrave',
          itemCount: json.item_count,
          sections: json.sections,
        })
      );
    } catch (e) {
      console.error(e);
      if (err) err.hidden = false;
      saveBtn.disabled = false;
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;

    var arrow = t.closest('[data-upsell-dir]');
    if (arrow) {
      var track = arrow.closest('.cart-upsell__block').querySelector('[data-upsell-track]');
      track.scrollBy({ left: Number(arrow.dataset.upsellDir) * track.clientWidth * 0.8, behavior: 'smooth' });
      return;
    }

    var add = t.closest('[data-upsell-add]');
    if (add) {
      upsellAdd(add);
      return;
    }

    var wrap = t.closest('[data-engrave]');
    if (!wrap) return;
    if (t.closest('[data-engrave-open]')) showForm(wrap, true);
    else if (t.closest('[data-engrave-cancel]')) showForm(wrap, false);
    else if (t.closest('[data-engrave-save]')) engraveSave(wrap);
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (el instanceof HTMLInputElement && el.hasAttribute('data-engrave-input')) {
      var v = cleanInitials(el.value);
      if (v !== el.value) el.value = v;
    }
  });

  document.addEventListener('keydown', function (e) {
    var el = e.target;
    if (e.key === 'Enter' && el instanceof HTMLInputElement && el.hasAttribute('data-engrave-input')) {
      e.preventDefault();
      var wrap = el.closest('[data-engrave]');
      if (wrap) engraveSave(wrap);
    }
  });
})();
